'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const React = require('react');
const components_navigation_Tabs_Tabs = require('./Tabs.cjs.js');
const utils_debounce = require('../../../utils/debounce.cjs.js');

const AutoTabs = (_a) => {
  var { items: itemsProp, selectedItemHref, shouldRenderTrack = true, onChooseItem = () => {
  } } = _a, tabProps = tslib_es6.__rest(_a, ["items", "selectedItemHref", "shouldRenderTrack", "onChooseItem"]);
  const navRef = React.useRef(null);
  const [items, setItems] = React.useState(itemsProp);
  React.useLayoutEffect(() => {
    const nav = navRef.current;
    const isOverflowing = !!nav && nav.scrollWidth > nav.offsetWidth;
    if (isOverflowing) {
      const hasExtraItems = items.some((item) => item.isExtra);
      const indexOfFirstExtraItem = hasExtraItems ? items.findIndex((item) => item.isExtra) : items.length;
      setItems(items.map((item, i) => {
        return i < indexOfFirstExtraItem - 1 ? item : Object.assign(Object.assign({}, item), { isExtra: true });
      }));
    }
  }, [items]);
  React.useLayoutEffect(() => {
    const onResize = utils_debounce.debounce(() => {
      setItems([...itemsProp]);
    }, 100);
    window.addEventListener("resize", onResize, { capture: true });
    return () => {
      window.removeEventListener("resize", onResize, { capture: true });
    };
  });
  React.useEffect(() => setItems([...itemsProp]), [itemsProp]);
  return react.jsx(components_navigation_Tabs_Tabs.Tabs, Object.assign({}, tabProps, { ref: navRef, items, selectedItemHref, onChooseItem, shouldRenderTrack }));
};

exports.AutoTabs = AutoTabs;
//# sourceMappingURL=AutoTabs.cjs.js.map
